"use client";
import { descriptionWithoutTitle as o } from "./utils/description-without-title.js";
const s = (t, r) => {
  if (r === "chatSourceItem") return t.description ?? void 0;
  const i = t.breadcrumbs ?? [], e = i.length > 0 ? i[i.length - 1] : void 0, n = t.title || e?.props?.str;
  return o(t.description, n);
};
export {
  s as getDescription
};
